import { Component } from '@angular/core';
import { OnInit, Input } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { UserService } from '../../services/user.service';

/**
 * Component providing a customizable confirmation dialog.
 */
@Component({
	selector: 'confirm',
	templateUrl: './confirm.component.html',
	styleUrl: './confirm.component.css'
})
export class ConfirmComponent implements OnInit {
	@Input() modal: any;

	LOCALIZATION: any;
	title: string = "";
	trustedMsg: SafeHtml = "";
	buttonClass: string = 'btn-default';
	customBtns: any[] = [];

	constructor(
		private sanitizer: DomSanitizer,
		private userService: UserService,
		private ngbmodalService: NgbActiveModal
	) { }

	ngOnInit(): void {
		this.LOCALIZATION = this.userService.LOCALIZATION;

		console.log('Modal:', this.modal);
		this.title = this.modal.title;
		this.trustedMsg = this.sanitizer.bypassSecurityTrustHtml(this.modal.message);
		this.buttonClass = this.getButtonClass(this.modal.type);
		this.customBtns = this.modal.customBtns || [];
	}

	/**
	 * Returns the button class for the specified type.
	 */
	getButtonClass(type: string): string {
		switch (type) {
			case 'danger': return 'btn-danger';
			case 'success': return 'btn-success';
			case 'info': return 'btn-info';
			case 'warning': return 'btn-warning';
			case 'primary': return 'btn-primary';
			default: return 'btn-default';
		}
	}

	/**
	 * Closes the modal, returning a result of ok and payload.
	 */
	proceed(): void {
		this.ngbmodalService.close({
			result: { answer: 'ok', caller: this.modal },
			timestamp: new Date(),
		});
	}

	/**
	 * Closes the modal.
	 */
	cancel(): void {
		this.ngbmodalService.dismiss();
	}
}
